import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.stopped = false
    this.schedule()
  }

  disconnect() {
    this.stopped = true
    clearTimeout(this.timer)
    this.request?.abort()
  }

  schedule() {
    if (!this.stopped && this.element.querySelector('[data-confirmation-pending="true"]')) {
      this.timer = setTimeout(() => this.refresh(), 5000)
    }
  }

  async refresh() {
    if (document.hidden) {
      this.schedule()
      return
    }
    this.request = new AbortController()
    const timeout = setTimeout(() => this.request.abort(), 10000)
    try {
      const response = await fetch(this.urlValue, {
        credentials: "same-origin", cache: "no-store",
        headers: { Accept: "text/html", "X-Orders-Refresh": "1" }, signal: this.request.signal
      })
      if (response.redirected) {
        this.stopped = true
        return
      }
      if (response.ok && !this.stopped) {
        const document = new DOMParser().parseFromString(await response.text(), "text/html")
        const updated = document.getElementById(this.element.id)
        if (!this.stopped && updated && updated.innerHTML !== this.element.innerHTML) {
          this.element.innerHTML = updated.innerHTML
        }
      }
    } catch (error) {
      // Keep the last known status during temporary network failures.
    } finally {
      clearTimeout(timeout)
      this.schedule()
    }
  }
}
